import { useMemo } from "react";
import { FORMATIONS, FORMATION_KEYS } from "../formations";
import DropdownFilter from "../dropdownFilter/dropdownFilter";
import "./formationFilter.sass";

/**
 * Filtro de alineación con dropdown personalizado
 * 
 * Componente que reemplaza el select nativo con un dropdown
 * personalizado. Permite seleccionar la alineación táctica con
 * una interfaz mejorada.
 * 
 * @component
 * @param {string} value - Valor actual de la alineación (ej: "4-3-3")
 * @param {Function} onChange - Callback al cambiar la alineación (recibe nueva alineación)
 * @param {string} [accentColor] - Color de acento para estilos (hex o CSS var)
 * 
 * @returns {JSX.Element} Dropdown con opciones de alineaciones
 */
export default function FormationFilter({ value, onChange, accentColor }) {
  // Convertir FORMATIONS a formato de opciones
  const options = useMemo(() => {
    return FORMATION_KEYS.map(key => ({
      value: key,
      label: FORMATIONS[key].label
    }));
  }, []);

  return (
    <DropdownFilter
      options={options}
      value={value}
      onChange={onChange}
      label="Alineación"
      ariaLabel="Seleccionar alineación"
      accentColor={accentColor}
      containerClass="formation-filter-container"
      buttonClass="formation-filter-button"
      dropdownClass="formation-filter-dropdown"
      optionClass="formation-filter-option"
    />
  );
}